import styled from 'styled-components';

export const StyledTag = styled.div`
  font-size: 18px;
  padding: 8px 12px;
  width: fit-content;
  font-weight: 500;
  background-color: ${(props) => props.theme.color.primaryLight};
  border-radius: ${(props) => props.theme.radius.md};
  color: ${(props) => props.theme.color.primary};
  border: 1px solid ${(props) => props.theme.color.primary};
  &:hover {
    background-color: ${(props) => props.theme.color.primary};
    color: #ffffff;
    border: 1px solid ${(props) => props.theme.color.primary};
  }
  &:focus {
    outline: none;
  }
`;
